const adminMenuItems = {
  items: [
    {
      id: 'admin-panel',
      title: 'Admin Login',
      type: 'group',
      icon: 'icon-monitor',
      url: '/admin-portal/admin-dashboard',
      children: [
        {
          id: 'admin-dashboard',
          title: 'Dashboard',
          type: 'item',
          icon: 'feather icon-bar-chart',
          url: '/admin-portal/admin-dashboard'
        },
        {
          id: 'admin-clientdetails',
          title: 'Client Details',
          type: 'item',
          icon: 'feather icon-list',
          url: '/admin-portal/admin-clientdetails'
        },
        {
          id: 'admin-userdetails',
          title: 'User Details',
          type: 'item',
          icon: 'feather icon-users',
          url: '/admin-portal/admin-userdetails'
        },
        {
          id: 'admin-employee-tracking',
          title: 'Employee Tracking',
          type: 'item',
          icon: 'feather icon-activity',
          url: '/admin-portal/admin-employee-tracking'
        },
        // {
        //   id: 'admin-vendordetails',
        //   title: 'Vendor Details',
        //   type: 'item',
        //   icon: 'feather icon-tag',
        //   url: '/admin-portal/admin-vendordetails'
        // },
        {
          id: 'admin-metrics',
          title: 'Graph Metrics',
          type: 'item',
          icon: 'feather icon-bar-chart',
          url: '/admin-portal/admin-metrics'
        },
        {
          id: 'admin-export-spoc',
          title: 'Export SPOC Details',
          type: 'item',
          icon: 'feather icon-download',
          url: '/admin-portal/admin-export-spoc'
        }
      ]
    }
  ]
};

export default adminMenuItems;
